import { Typography } from '@mui/material';
import { InvoiceItem } from 'types/graphql';

import { Card, LineItemTable } from 'src/components';
import { CREDIT_NOTE_LINE_ITEM_COLUMN_HEADERS } from 'src/constants';
interface CreditNoteLineItemsProps {
    lineItems: InvoiceItem[];
    usersCurrency: string;
}

const CreditNoteLineItems = ({ lineItems, usersCurrency }: CreditNoteLineItemsProps) => {
    return (
        <Card gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Credit Items
            </Typography>
            <LineItemTable
                columnHeaders={CREDIT_NOTE_LINE_ITEM_COLUMN_HEADERS}
                data={lineItems?.map(
                    ({ description, ledgerAccount, lineTotal, netAmount, totalVat, quantity }) => {
                        return {
                            quantity,
                            description,
                            ledgerAccount,
                            lineTotal,
                            netAmount,
                            totalLineVat: totalVat,
                        };
                    }
                )}
                showLedgerAccount={CREDIT_NOTE_LINE_ITEM_COLUMN_HEADERS.includes('Ledger Account')}
                usersCurrency={usersCurrency}
            />
        </Card>
    );
};
export default CreditNoteLineItems;
